import { css, SerializedStyles } from '@emotion/react';
import fieldStyle from './field.style';

const freeTextTitle = (isValid: boolean, isItalic = false): SerializedStyles => css`
  ${fieldStyle.freeTextTitle(isValid, isItalic)}
`;

const validationIcon = css`
  ${fieldStyle.validationIcon}
`;

const field = css`
  ${fieldStyle.labeledField}
`;

const editableField = css`
  ${fieldStyle.labeledEditableField}
`;

const editIcon = css`
  ${fieldStyle.editIcon}
`;

const modal = css`
  ${fieldStyle.modal}
`;

const modalContent = css`
  ${fieldStyle.modalContent};
`;

const inputContainer = css`
  &&&& {
    textarea {
      border-color: var(--saa-primary-color-10);
      outline: none;
      width: 100%;
      height: 235px;
      max-height: 235px;
      min-width: 250px;
      min-height: 235px;
      overflow: auto;
      resize: none;
    }
  }
`;

const actions = css`
  display: flex;
  justify-content: flex-end;
`;

const button = css`
  ${fieldStyle.button}
  flex: 1;
  min-width: max-content;
  max-width: 120px;
`;

export default {
  freeTextTitle,
  field,
  editableField,
  editIcon,
  modal,
  modalContent,
  inputContainer,
  actions,
  button,
  validationIcon,
};
